export const BOUNDING_BOX_PARAMS = [
    'neLat',
    'neLong',
    'swLat',
    'swLong',
    'zoom'
];
